export const EXPIRY_MINUTES: number | null =
  process.env.NODE_ENV === 'production' ? 1440 : 1440;

export const UNAUTHENTICATED_EXPIRY_MINUTES: number | null =
  process.env.NODE_ENV === 'production' ? 1440 : 5;
export const LOCKED = '*';

export const DAY_MINISECONDS = EXPIRY_MINUTES * 60000;
